<template>
  <div class="page">
    <Menu />
    <section class="cContent">
      <!-- <ul class="tab">
                <li class="active">分类一</li>
                <li>分类二</li>
                <li>分类三</li>
      </ul>-->
      <div class="list">
        <CoursePkgList :list="coursePkgObj.data" />
      </div>
        <pager
          :total-page="Math.ceil(coursePkgObj.total / pageSize)"
          :init-page="coursePkgObj.current_page"
          @go-page="goPage"
        ></pager>
    </section>
    <Footer />
  </div>
</template>

<script> 
import Menu from "@/components/Menu.vue";
import CoursePkgList from "@/components/CoursePkgList.vue";
import Footer from "@/components/Footer.vue";
import pager from "@/components/pager.vue";

import { coursePkgList } from "@/api/course.js";

export default {
  data() {
    return {
      page: 1,
      pageSize: 20,
      coursePkgObj: {}
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData: function() {
      coursePkgList(this.page, this.pageSize).then(resp => {
        if (resp != -1) {
          this.coursePkgObj = resp;
        }
      });
    },
    goPage: function(e) {
      this.page = e.page;
      this.loadData();
    }
  },
  components: {
    Menu,
    Footer,
    CoursePkgList,
    pager
  }
};
</script>

<style lang="scss" scoped>
body{background: white;}
.page{background: white;}
.cContent{
  width: 1200px;margin:0 auto;background: white;padding-bottom:30px;
  .list{padding:10px 0;margin:20px 0;min-height:500px;}
}
</style>